import React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface LogoutConfirmModalProps {
  show: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const LogoutConfirmModal: React.FC<LogoutConfirmModalProps> = ({ show, onConfirm, onCancel }) => (
  <Modal show={show} onHide={onCancel} centered>
    <Modal.Header closeButton>
      <Modal.Title>Sign out</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      Are you sure you want to sign out?
    </Modal.Body>
    <Modal.Footer>
      <Button variant="outline-secondary" onClick={onCancel}>
        Cancel
      </Button>
      <Button variant="primary" onClick={onConfirm}>
        Sign out
      </Button>
    </Modal.Footer>
  </Modal>
);

export default LogoutConfirmModal;
